import React from 'react';

import { useTheme } from '@mui/material/styles';

function GlobeIcon({ isActive }) {
    const theme = useTheme();

    const color = isActive ? theme.palette.primary.main : theme.palette.icons.color;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <path stroke={color} strokeWidth={2} d="M4 9h16.364M4 15h16.364" />
            <circle cx={12} cy={12} r={9} stroke={color} strokeWidth={2} />
            <ellipse cx={12} cy={12} stroke={color} strokeWidth={2} rx={3.273} ry={9} />
        </svg>
    );
}

export default GlobeIcon;
